import { t } from 'i18next'
import Lottie from 'assets/img/lotties/welcome.json'
import { ID_ELEMETS_WALKTHROUGH } from 'components/Walkthrough'
import {
  ALIGN,
  POSITION,
  TYPE,
} from 'components/Walkthrough/Walkthrough.helper'
import { TYPES_USER_ROLES } from 'utils/constants'

const filterStepWalkthrough = (step, condition = true) => {
  return condition ? [step] : []
}

export const getSteps = ({
  flags: { hasCatalogue, hasEvaluations },
  isMobile,
  role,
  user: { userFullName, yearBegin, yearEnd },
}) => {
  const isTeacher = role === TYPES_USER_ROLES.TEACHER
  const isStudent =
    role === TYPES_USER_ROLES.STUDENT ||
    role === TYPES_USER_ROLES.STUDENT_UNDER_14

  return [
    ...filterStepWalkthrough({
      buttons: {
        nextTitle: t('Empezar'),
      },
      lottie: !isMobile ? Lottie : null,
      subtitle: (
        <>
          {t('Para este nuevo curso hemos renovado nuestra imagen')}
          <br />
          {t('¡Te la enseñamos!')}
        </>
      ),
      title: t(
        '¡Hola {{user}}! Bienvenido/a al curso {{yearBegin}}-{{yearEnd}}',
        {
          user: userFullName,
          yearBegin,
          yearEnd,
        }
      ),
      type: TYPE.BIG,
    }),
    ...filterStepWalkthrough(
      {
        buttons: {
          nextTitle: t('Siguiente'),
          previousTitle: t('Anterior'),
        },
        id: ID_ELEMETS_WALKTHROUGH.BUTTON_HOME,
        location: {
          tablet: {
            align: ALIGN.CENTER,
            position: POSITION.TOP,
          },
          web: {
            align: ALIGN.END,
            position: POSITION.IN_LINE,
          },
        },
        subtitle: t(
          'Aquí encontrarás las últimas novedades, recordatorios a webinars y acceso rápido a tus contenidos'
        ),
        title: t('Escritorio'),
      },
      isTeacher
    ),
    ...filterStepWalkthrough(
      {
        buttons: {
          nextTitle: t('Siguiente'),
          previousTitle: t('Anterior'),
        },
        id: ID_ELEMETS_WALKTHROUGH.BUTTON_CLASSROOM,
        location: {
          tablet: {
            align: ALIGN.CENTER,
            position: POSITION.TOP,
          },
          web: {
            align: ALIGN.END,
            position: POSITION.IN_LINE,
          },
        },
        subtitle: (
          <>
            {t(
              'Desde aquí podrás consultar recursos y materiales, gestionar las calificaciones de tus alumnos y vincularte a nuevas clases'
            )}
            <br />
            <br />
            {t(
              'Además ahora puedes acceder a una clase y configurar la manera en la que quieres que se calculen las notas de tus alumnos'
            )}
          </>
        ),
        title: t('Tus clases'),
      },
      isTeacher
    ),
    ...filterStepWalkthrough(
      {
        buttons: {
          nextTitle: t('Siguiente'),
          previousTitle: t('Anterior'),
        },
        id: ID_ELEMETS_WALKTHROUGH.BUTTON_BOOKS,
        location: {
          tablet: {
            align: ALIGN.CENTER,
            position: POSITION.TOP,
          },
          web: {
            align: ALIGN.END,
            position: POSITION.IN_LINE,
          },
        },
        subtitle: t(
          'Accede a tus libros para consultar su contenido, ver recursos y añadir nuevos libros'
        ),
        title: t('Tus libros y recursos'),
      },
      isTeacher || isStudent
    ),
    ...filterStepWalkthrough(
      {
        buttons: {
          nextTitle: t('Siguiente'),
          previousTitle: t('Anterior'),
        },
        id: ID_ELEMETS_WALKTHROUGH.BUTTON_ASSESSMENT,
        location: {
          tablet: {
            align: ALIGN.CENTER,
            position: POSITION.TOP,
          },
          web: {
            align: ALIGN.END,
            position: POSITION.IN_LINE,
          },
        },
        subtitle: t(
          'Crea evaluaciones de los contenidos de tus libros para tus alumnos y alumnas de clase'
        ),
        title: t('Generador de evaluaciones'),
      },
      isTeacher && hasEvaluations
    ),
    ...filterStepWalkthrough(
      {
        buttons: {
          nextTitle: t('Siguiente'),
          previousTitle: t('Anterior'),
        },
        id: ID_ELEMETS_WALKTHROUGH.BUTTON_CATALOGUE,
        location: {
          tablet: {
            align: ALIGN.CENTER,
            position: POSITION.TOP,
          },
          web: {
            align: ALIGN.END,
            position: POSITION.IN_LINE,
          },
        },
        subtitle: t(
          'Aquí encontrarás libros digitales de muestra que podrían interesarte Accede al catálogo y descúbrelos'
        ),
        title: t('Catálogo'),
      },
      isTeacher && hasCatalogue
    ),
  ]
}
